import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const InternalLink = styled(Link)`
  color: ${p => p.theme.text.callToAction};

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
    text-decoration: underline;
  }
`;
